/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Ref_H1Inputs */

const en_formatter_ref_h1 = /** @type {(inputs: Formatter_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input`)
};

const ko_formatter_ref_h1 = /** @type {(inputs: Formatter_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입력`)
};

const ja_formatter_ref_h1 = /** @type {(inputs: Formatter_Ref_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力`)
};

/**
* | output |
* | --- |
* | "Input" |
*
* @param {Formatter_Ref_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_ref_h1 = /** @type {((inputs?: Formatter_Ref_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Ref_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_ref_h1(inputs)
	if (locale === "ko") return ko_formatter_ref_h1(inputs)
	return ja_formatter_ref_h1(inputs)
});